export const PURPLEZONE_SERVER_ID_KEY = 'pzsid';
export const PURPLEZONE_CHARACTER_ID_KEY = 'pzcid';

export const DETAIL_STATE = {
    ITEM: 'item',
    SPELL: 'spell',
    SKILL: 'skill',
    POLYMORPH: 'polymorph',
    MAGICDOLLS: 'magicdolls',
};

export const NOTI_LAYER_STATE = {
    SEARCH: 'search',
    MODIFY: 'modify',
    LIST: 'list',
    WRITE: 'write',
};
